import React, { useMemo, useRef, useState } from 'react';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowUp from '@mui/icons-material/KeyboardArrowUp';
import cx from 'classnames';

import useOnClickOutside from '../../../helpers/useOnClickOutside';
import { SortType } from '../../../enums/SORT';
import styles from './Selector.module.scss';

type TSelector = {
  title: string;
  style?: any;
  className?: string;
  selectedValue: string;
  selectedOrder: SortType;
  options: { label: string; value: string; order: SortType }[];
  onSelect: (_: any, value?: { label: string; value: string; order: SortType }) => void;
};

export const OrderSelector: React.FC<TSelector> = ({ title, style, className, options, selectedValue, selectedOrder, onSelect }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [opened, setOpened] = useState(false);

  useOnClickOutside(ref, (e) => {
    e.stopPropagation();
    setOpened(false);
  });

  const isValueSelected = useMemo(() => {
    return options.find((v) => v.value === selectedValue && v.order === selectedOrder);
  }, [selectedValue, selectedOrder]);

  return (
    <div onClick={() => setOpened(!opened)} style={style && { ...style }} className={cx(styles.container, className)} ref={ref}>
      <div className={styles.title}>
        <span>{isValueSelected ? isValueSelected.label : title}</span> {opened ? <ArrowUp /> : <ArrowDown />}
      </div>
      {opened && (
        <div className={styles.selector} style={style && { ...style }}>
          {options.map((op) => (
            <div
              className={cx(
                styles.option,
                isValueSelected?.value === op.value && isValueSelected.order === op.order && styles.selectedOption,
              )}
              key={op.label}
              onClick={() => onSelect(op.value, op)}
            >
              {' '}
              {op.label}{' '}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
